import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ChartHorizontalMultiBar } from 'src/common/charts';
import { fetchMilitaryReports } from 'actions/Report/Contact/Military';
import _ from 'lodash';
import { genderPartitions } from '../../utils/partitions';
import { genderColors } from '../../utils/colors';
import sortByTitleNoResponseLast from '../../utils/sortByTitleNoResponseLast';

export default class StatusByGender extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.state = {
      statusByGender: [],
      title: '',
    };
  }

  componentDidMount() {
    this.fetchData(this.props.filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.filters, nextProps.filters)) {
      this.fetchData(nextProps.filters);
    }
  }

  fetchData(filters) {
    const { scope, id } = this.props;
    fetchMilitaryReports(scope, id, 'status/by-gender', { partitions: genderPartitions(), ...filters })
      .then((response) => {
        const data = _.get(response, 'data', {});
        data.values = sortByTitleNoResponseLast(data.values);
        this.setState({
          statusByGender: data,
          title: _.get(response, 'data.title', ''),
        });
        this.props.loaded('statusByGender');
      });
  }

  render() {
    if (_.isEmpty(this.state.statusByGender)) {
      return null;
    }
    return (
      <ChartHorizontalMultiBar
        data={this.state.statusByGender}
        x={(d) => _.truncate(d.title, { length: 30 })}
        y={(d) => d.total}
        title={this.state.title}
        margin={{ left: 200, top: 60 }}
        showValues
        showYAxis
        showLegend
        stacked
        valueFormat="d"
        colors={genderColors}
        xLabel="Service Status"
        colWidths={{
          x: '270px',
        }}
      />
    );
  }
}

StatusByGender.propTypes = {
  filters: PropTypes.shape({
    end_date: PropTypes.string,
    network_ids: PropTypes.array,
    start_date: PropTypes.string,
  }),
  loaded: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};
